<template>
  <div
    class="c-aed-editableDropdown"
    :class="{
      active: isEditing,
      error: error,
      'c-aed-editableDropdown--textAligned': textAligned
    }"
    :ref="_uid"
  >
    <v-select
      :label="label"
      v-model="mutableValue"
      :resetOnOptionsChange="true"
      :placeholder="translationsCustom.addValue"
      :options="options"
      :clearable="false"
      :select-on-tab="true"
      ref="select"
      @search:focus="handleFocus"
      @input="valueChange($event)"
    >
      <span slot="no-options">{{ translationsCustom.noOptionsAvailable }}</span>
    </v-select>
    <div
      class="c-aed-editableDropdown__editable-icon o-button o-button--light-blue o-button--action o-button--square"
      v-if="!isEditing"
    >
      <svg class="o-svg-icon" viewBox="0 0 64 64" type="image/svg+xml">
        <use xlink:href="spritemap.svg#sprite-edit" x="0" y="0"></use>
      </svg>
    </div>
    <button
      class="o-button o-button--action o-button--round"
      v-if="isEditing && submitable"
      @click="save"
      @blur="submitIfLeave"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-check-thinline" x="0" y="0"></use>
      </svg>
    </button>
    <button
      class="o-button o-button--action o-button--round o-button--light"
      v-if="isEditing && canCancel"
      @click="cancel"
      @blur="submitIfLeave"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-cross" x="0" y="0"></use>
      </svg>
    </button>
    <div
      v-if="!isEditing && !mutableValue.isSelectable && showAttentionIcon"
      class="c-aed-editableDate__error-icon o-button o-button--transparent o-button--action o-button--square"
    >
      <svg
        class="o-svg-icon o-button__icon"
        viewBox="0 0 64 64"
        type="image/svg+xml"
      >
        <use xlink:href="spritemap.svg#sprite-field-error" x="0" y="0"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-aed-editableDropdown",
  data() {
    return {
      isEditing: false,
      error: false,
      mutableValue: {}
    };
  },
  props: {
    section: { required: true },
    submitName: { required: true },
    mutableName: { required: true },
    initialValue: { required: true },
    options: { required: true },
    label: { type: String, default: "name" },
    canSubmit: { type: Boolean, default: true },
    editState: { type: Boolean, default: false },
    canCancel: { type: Boolean, default: true },
    textAligned: { type: Boolean, default: false },
    showAttentionIcon: { type: Boolean, default: false }
  },
  computed: {
    ...mapState("translations", {
      translationsCustom: "custom"
    }),
    submitable() {
      return (
        this.options.length > 0 && this.mutableValue !== null && this.canSubmit
      );
    }
  },
  created() {
    this.mutableValue = JSON.parse(JSON.stringify(this.initialValue));
    this.isEditing = JSON.parse(JSON.stringify(this.editState));
  },
  watch: {
    initialValue: function(newVal) {
      this.mutableValue = newVal;
    },
    editState: function(newVal) {
      this.isEditing = newVal;
    }
  },
  methods: {
    save() {
      this.isEditing = false;
      // this.error = true;
      if (
        this.mutableValue[this.mutableName] !== "" &&
        this.mutableValue !== this.initialValue
      ) {
        let payload = {
          api: this.$api,
          id: this.$store.state.aed.all.id,
          section: this.section,
          method: "PATCH",
          data: {
            [this.submitName]: this.mutableValue[this.mutableName]
          }
        };

        this.$store.dispatch("aed/setSection", payload);
        this.$emit("valueSave");
      }
    },
    cancel() {
      this.isEditing = false;
      this.error = false;
      this.$nextTick(() => {
        this.mutableValue = this.initialValue;
      });
      this.$emit("valueReset");
    },
    valueChange(value) {
      this.error = false;
      this.$emit("valueChange", value);
    },
    submitIfLeave(event) {
      if (
        this.$refs[this._uid] ===
        (event.relatedTarget && event.relatedTarget.parentElement)
      ) {
        return;
      }
      this.submitable && this.isEditing && this.save();
    },
    onClickOutside(event) {
      event.stopPropagation();

      if (
        this.$refs[this._uid] ===
        event.target.parentElement.closest(".c-aed-editableDropdown")
      ) {
        return;
      }
      this.submitable && this.isEditing && this.save();
      document.removeEventListener("mousedown", this.onClickOutside);
      this.isEditing = false;
    },
    handleFocus() {
      this.isEditing = true;
      document.addEventListener("mousedown", this.onClickOutside);
    }
  }
};
</script>
<style lang="scss">
$input-left-padding: 10px;
.c-aed-editableDropdown {
  $root: &;
  $dropdown-component: ".v-select";
  $dropdown: #{$dropdown-component + " .vs__search"};
  display: flex;
  position: relative;
  width: 100%;

  &--textAligned {
    margin-left: -$input-left-padding;
    width: calc(100% + 10px); //TODO INTERPOLATION does not work
  }

  &:not(.active) {
    #{$dropdown} {
      text-overflow: ellipsis;
    }
    #{$dropdown-component} {
      .vs {
        &__actions {
          display: none;
        }
      }
    }
  }

  &:hover {
    #{$dropdown} {
      border: 1px solid $s-cp-neutral-600;
    }
    div#{$root}__editable-icon {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &.active {
    #{$dropdown} {
      border: 1px solid $s-cp-neutral-600;

      &:focus {
        outline: $s-cp-sup-focus auto 1px;
      }
    }
  }

  &.error {
    #{$dropdown} {
      border: 1px solid $s-cp-sup-red;
      color: $s-cp-sup-red;

      &:focus {
        outline: $s-cp-sup-red auto 1px;
      }
    }
  }

  div#{$root}__editable-icon {
    display: none;
    pointer-events: none;
  }

  .o-button {
    flex: 0 0 auto;
    + .o-button {
      margin-left: 5px;
    }
  }

  .v-select {
    width: 100%;

    &--open {
      .vs__selected {
        height: 100%;
      }
    }
    .vs {
      &__search,
      &__search:focus {
        height: toRem(30px);
        vertical-align: middle;
        border: 1px solid transparent;
        flex: 1 1 100%;
        width: 100%;
        @include setStyles("15", $s-typography-sizes);
        line-height: 19px;
        padding: 0 10px;
        margin: 0;
      }
      &__selected-options {
        padding: 0;
      }
      &__selected {
        position: absolute;
        margin: 0;
        border: none;
        height: 100%;
        padding: 5px $input-left-padding 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        width: 100%;
        @include setStyles("15", $s-typography-sizes);
        line-height: 19px;
      }
      &__open-indicator {
        stroke-width: 2px;
        stroke: white;
      }

      &__dropdown-toggle {
        padding: 0;
        border: none;
      }
      &__dropdown-menu {
        margin: 1px 0;
      }
      &__dropdown-option {
        padding: 3px 10px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    + .o-button {
      margin-left: 7px;
    }
  }
}

.v-select {
  .vs {
    &__actions {
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
      padding: 0 0 0 3px;
    }
    &__open-indicator {
      stroke-width: 2px;
      stroke: white;
    }
  }
}
</style>
